import React from 'react';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import { useReportsContext } from 'partial/wrappers/ReportsContext';
import Badges from 'modules/common/components/Badge';
import { useOpenViewTransaction } from 'modules/transactions/modals/ViewTransaction';
import { AiOutlineEye } from 'react-icons/ai';

const labelClassName = 'whitespace-nowrap';
const contentClassName = 'whitespace-nowrap';

export default function PaymentTransactions() {
  const { isLoading, list, meta, setPage } = useReportsContext();
  const viewTransaction = useOpenViewTransaction();

  const format = [
    { label: 'DATE OF TRANSACTION', key: 'created_at' },
    { label: 'ORGANIZATION NAME', key: 'organization_name' },
    {
      id: 'updated_at',
      label: 'DATE PAID',
      key: ({ status, updated_at }) => (
        <span>{status === 'DRAFT' ? '--' : updated_at}</span>
      ),
    },
    {
      id: 'refno',
      label: 'REFERENCE NO.',
      key: ({ status, refno }) => (
        <span>{status === 'DRAFT' ? '--' : refno}</span>
      ),
    },
    {
      id: 'balance',
      label: 'AMOUNT',
      key: ({ debit, credit }) => <span>P {+debit ? debit : credit}</span>,
      labelClassName: 'pr-10 whitespace-nowrap flex justify-end',
      contentClassName: 'pr-10 whitespace-nowrap text-right',
    },
    {
      id: 'status',
      label: 'STATUS',
      key: ({ status }) => <Badges status={status} />,
    },
    {
      id: 'view',
      label: '',
      key: (item) => (
        <button
          type="button"
          onClick={() => viewTransaction(item)}
          className="p-px border-none hover:bg-primary text-primary hover:text-white rounded transition"
        >
          <AiOutlineEye className="w-4 h-4" />
        </button>
      ),
    },
  ].map((item) => ({
    ...item,
    labelClassName,
    contentClassName,
  }));

  return (
    <div className="flex flex-col gap-10 min-h-[65vh]">
      <Table isLoading={isLoading} data={list} format={format} />
      {!isLoading && <Pagination value={meta} onChange={setPage} />}
    </div>
  );
}
